import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_FILTER_BUTTON: `${cleanedFilename(__filename)}-add-filter-button`,
  FILTER_REPRESENTATION_CONTAINER: `${cleanedFilename(
    __filename,
  )}-filter-representation-container`,
};
